import { MrInputSink } from '@mrhenry/wp--mr-interactive';

customElements.define( 'mr-overlay-trigger', MrInputSink );
